export const wan = {
  disable_dos: "disable_spi",
};

export default wan;
